export default {
  periwoundOtherText: '',
  showPeriwoundOtherLabel: false,
  showPeriwoundOtherTextbox: false,
  periwoundOtherParamCode: '',
  periwoundUnknownParamCode: '',
  disableOtherParams: false,
  periwoundList: [],
};
